// Central site data, contact info and WhatsApp helpers for Miríade Turismo.

export const COMPANY = {
  name: "Miríade Turismo",
  tagline:
    "Sua agência de viagens para descobrir o mundo com mais segurança, praticidade e atendimento humano.",
  phoneDisplay: "(17) 99114-0206",
  whatsappNumber: "5517991140206",
  email: "mirian@miriadeturismo.com.br",
  address: {
    street: "Avenida Murchid Homsi, 873 — Parque Celeste",
    city: "São José do Rio Preto",
    state: "SP",
    zip: "15070-415",
  },
  hours: "Segunda a sexta, das 9h às 18h",
  cnpj: "48.948.030/0001-50",
  instagram: "https://www.instagram.com/miriadeturismo",
  facebook: "https://www.facebook.com/miriadeturismo",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_miriade-turismo-novo/artifacts/vbxq6sst_WhatsApp%20Image%202026-06-05%20at%2013.58.20%20%281%29.jpeg",
  mascot: "/mascote-fundo-transparente.png",
  ceo: "/foto-ceo.png",
  heroCouple:
    "https://images.unsplash.com/photo-1701401942416-bea590efe2ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  national:
    "https://images.pexels.com/photos/29949374/pexels-photo-29949374.jpeg?auto=compress&cs=tinysrgb&w=1200",
  international:
    "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  resorts:
    "https://images.pexels.com/photos/8680959/pexels-photo-8680959.jpeg?auto=compress&cs=tinysrgb&w=1200",
  cruises:
    "https://images.pexels.com/photos/32609062/pexels-photo-32609062.jpeg?auto=compress&cs=tinysrgb&w=1200",
  family:
    "https://images.pexels.com/photos/8623320/pexels-photo-8623320.jpeg?auto=compress&cs=tinysrgb&w=1200",
  honeymoon:
    "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  holidays:
    "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  groups:
    "https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

const DEFAULT_MSG =
  "Olá, vim pelo site da Miríade Turismo e gostaria de ajuda para escolher uma viagem.";

export const waLink = (message = DEFAULT_MSG) =>
  `https://wa.me/${COMPANY.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  default: DEFAULT_MSG,
  consultant:
    "Olá, vim pelo site da Miríade Turismo e gostaria de falar com uma consultora.",
  doubts:
    "Olá, vim pelo site da Miríade Turismo e tenho algumas dúvidas antes de viajar.",
  national:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda com pacotes nacionais.",
  international:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda com viagens internacionais.",
  resorts:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda para escolher um resort.",
  cruises:
    "Olá, vim pelo site da Miríade Turismo e quero saber mais sobre cruzeiros.",
  family:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda para planejar uma viagem em família.",
  honeymoon:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda para planejar uma lua de mel.",
  holidays:
    "Olá, vim pelo site da Miríade Turismo e quero ajuda para viajar em feriados ou férias.",
  groups:
    "Olá, vim pelo site da Miríade Turismo e quero saber mais sobre grupos com guia.",
  insurance:
    "Olá, vim pelo site da Miríade Turismo e gostaria de orientação sobre seguro viagem.",
  documents:
    "Olá, vim pelo site da Miríade Turismo e tenho dúvidas sobre documentação para viajar.",
  work:
    "Olá, vim pelo site da Miríade Turismo e gostaria de enviar meu currículo / trabalhar com vocês.",
};

export const NAV_LINKS = [
  { label: "Início", to: "/" },
  { label: "Buscar Viagens", to: "/buscar-viagens" },
  { label: "Conheça", to: "/conheca" },
  { label: "Seguro Viagem", to: "/seguro-viagem" },
  { label: "Documentos", to: "/documentos" },
  { label: "Dúvidas", to: "/perguntas-frequentes" },
  { label: "Contato", to: "/contato" },
];

export const FOOTER_LINKS = {
  institucional: [
    { label: "Conheça a Miríade", to: "/conheca" },
    { label: "Buscar Viagens", to: "/buscar-viagens" },
    { label: "Trabalhe Conosco", to: "/trabalhe-conosco" },
    { label: "Avalie sua Viagem", to: "/avalie-sua-viagem" },
  ],
  ajuda: [
    { label: "Perguntas Frequentes", to: "/perguntas-frequentes" },
    { label: "Documentos para Viajar", to: "/documentos" },
    { label: "Seguro Viagem", to: "/seguro-viagem" },
    { label: "Segurança", to: "/seguranca" },
  ],
  legal: [
    { label: "Termos de Uso", to: "/termos-de-uso" },
    { label: "Política de Privacidade", to: "/politica-de-privacidade" },
    { label: "Contato", to: "/contato" },
  ],
};

export const CATEGORIES = [
  { title: "Pacotes nacionais", image: ASSETS.national, wa: WA_MESSAGES.national, cta: "Quero pacotes nacionais", desc: "Descubra o Brasil de norte a sul." },
  { title: "Pacotes internacionais", image: ASSETS.international, wa: WA_MESSAGES.international, cta: "Quero viagens internacionais", desc: "O mundo inteiro ao seu alcance." },
  { title: "Resorts", image: ASSETS.resorts, wa: WA_MESSAGES.resorts, cta: "Quero resorts", desc: "Conforto e lazer com tudo incluído." },
  { title: "Cruzeiros", image: ASSETS.cruises, wa: WA_MESSAGES.cruises, cta: "Quero cruzeiros", desc: "Navegue por destinos inesquecíveis." },
  { title: "Viagens em família", image: ASSETS.family, wa: WA_MESSAGES.family, cta: "Quero viagem em família", desc: "Momentos para todas as idades." },
  { title: "Lua de mel", image: ASSETS.honeymoon, wa: WA_MESSAGES.honeymoon, cta: "Quero lua de mel", desc: "O começo perfeito a dois." },
  { title: "Feriados e férias", image: ASSETS.holidays, wa: WA_MESSAGES.holidays, cta: "Quero viajar no feriado", desc: "Aproveite cada data especial." },
  { title: "Grupos com guia", image: ASSETS.groups, wa: WA_MESSAGES.groups, cta: "Quero grupo com guia", desc: "Roteiros guiados e acompanhados." },
];

export const TRUST_ITEMS = [
  {
    icon: "Heart",
    title: "Atendimento próximo",
    text: "Você pesquisa online, mas não fica sozinho. A equipe da Miríade pode ajudar na escolha e nas dúvidas.",
  },
  {
    icon: "ShieldCheck",
    title: "Mais segurança para decidir",
    text: "Orientação para comparar opções, entender detalhes da viagem e escolher com tranquilidade.",
  },
  {
    icon: "Search",
    title: "Praticidade na busca",
    text: "Pesquise destinos, datas e experiências em poucos cliques.",
  },
  {
    icon: "LifeBuoy",
    title: "Apoio em cada etapa",
    text: "Antes da viagem, durante a preparação e no pós-venda, a Miríade está ao seu lado.",
  },
];

export const HERO_BADGES = [
  "Atendimento personalizado",
  "Suporte na escolha da viagem",
  "Experiência simples e segura",
  "Viagens nacionais e internacionais",
];

export const FAQ_CATEGORIES = [
  {
    category: "Compra de viagens",
    items: [
      {
        q: "Como faço para comprar uma viagem pelo site?",
        a: "Use a área Buscar Viagens para pesquisar destinos, datas e opções. Se preferir, fale com uma consultora da Miríade pelo WhatsApp e nós ajudamos você em cada passo da escolha.",
      },
      {
        q: "Preciso fechar tudo online ou posso contar com ajuda?",
        a: "Você decide. É possível pesquisar com total praticidade pelo site e, sempre que quiser, contar com o atendimento humano da Miríade para tirar dúvidas e finalizar com mais tranquilidade.",
      },
    ],
  },
  {
    category: "Atendimento",
    items: [
      {
        q: "Como falo com a equipe da Miríade?",
        a: "O canal mais rápido é o WhatsApp, disponível em todas as páginas do site. Você também pode usar a página de Contato para enviar uma mensagem.",
      },
      {
        q: "Qual o horário de atendimento?",
        a: "Atendemos de segunda a sexta, das 9h às 18h. Mensagens enviadas fora desse período são respondidas no próximo dia útil.",
      },
    ],
  },
  {
    category: "Pagamento",
    items: [
      {
        q: "Quais são as formas de pagamento?",
        a: "As condições podem variar conforme a viagem escolhida. Para conhecer as opções disponíveis para o seu caso, fale com a equipe da Miríade antes de finalizar.",
      },
    ],
  },
  {
    category: "Documentação",
    items: [
      {
        q: "Quais documentos preciso para viajar?",
        a: "Depende do destino e do perfil do viajante. Reunimos orientações gerais na página Documentos, mas recomendamos sempre confirmar tudo com a equipe da Miríade antes da viagem.",
      },
      {
        q: "Crianças e adolescentes precisam de autorização?",
        a: "Viagens com menores de idade podem exigir documentos e autorizações específicas. Consulte a página Documentos e confirme os detalhes com a nossa equipe.",
      },
    ],
  },
  {
    category: "Alterações e cancelamentos",
    items: [
      {
        q: "É possível alterar ou cancelar uma viagem?",
        a: "As regras de alteração e cancelamento variam conforme cada serviço e fornecedor. Por isso, oriente-se sempre com a equipe da Miríade para entender as condições aplicáveis à sua viagem.",
      },
    ],
  },
  {
    category: "Seguro viagem",
    items: [
      {
        q: "Vale a pena contratar seguro viagem?",
        a: "O seguro viagem traz mais tranquilidade diante de imprevistos. Saiba mais na página Seguro Viagem e fale com a Miríade para orientação sobre a melhor opção para o seu roteiro.",
      },
    ],
  },
  {
    category: "Dúvidas gerais",
    items: [
      {
        q: "A Miríade atende viagens nacionais e internacionais?",
        a: "Sim. Ajudamos você a planejar tanto viagens pelo Brasil quanto destinos internacionais, com atendimento próximo do início ao fim.",
      },
      {
        q: "Não sei por onde começar. Vocês ajudam?",
        a: "Com certeza! Conte para a gente o que você imagina para a viagem e nossa equipe ajuda a encontrar o melhor caminho. Chame no WhatsApp.",
      },
    ],
  },
];
